import * as React from "react";
import { useCountryValue } from "../Contexts/CountryContext";
function PhoneNumber() {
  var state = useCountryValue()[0];
  var phoneInfo = state.callData.countries[state.country];
  var landline = phoneInfo.number,
    mobile = phoneInfo.mobileNumber;
  var phoneNumber = landline;
  if (state.country === "de" && state.device === "mobile") {
    phoneNumber = mobile;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, phoneNumber);
}
export default PhoneNumber;